<template>
  <app-modalData :init = "metaData"  @f="f($event)"  v-if="metaData">
    <span slot="status">
      <span v-if="results.updating.inProccess" style="font-size:1.3em; margin:5px;color:#727272">   выполняется обновление.... </span>
      <span v-if="results.updating.auto && !results.updating.inProccess"  style="font-size:1.3em; margin:5px;color:#727272"> Обновление через {{autoUpdater}}</span>

     </span>


     <div slot="icons">
       <v-icon   v-bind:class="{actives: results.updating.auto}" @click="autoUpdaterStarter()">mdi-autorenew</v-icon>
       <v-icon @click="reUpdater()" >mdi-update</v-icon>
       <v-icon medium @click="close()">mdi-close</v-icon>

     </div>

    <div slot="operations">
      <v-dialog  v-model="autoparams" width="500">
    <v-card>
    <v-card-text>

      <p style="color:#757575;font-size:1.3em"> Через какое время обновлять процесс  ?</p>
        <v-layout row>



          <v-flex class="px-3">
            <v-subheader>Часы</v-subheader>
           <v-slider
           max="23"
           v-model="results.updating.intervalSet.hours"
           color="primary"
           thumb-label="always"
           ></v-slider>
           </v-flex>

           <v-flex class="px-3">
             <v-subheader>Минуты</v-subheader>
            <v-slider
            v-model="results.updating.intervalSet.min"
            max="59"
            color="primary"
            thumb-label="always"
            ></v-slider>
            </v-flex>


          <v-flex class="px-3">
            <v-subheader>Секунды</v-subheader>
            <v-slider
            v-model="results.updating.intervalSet.sec"
            max="59"
            color="primary"
            thumb-label="always"
            ></v-slider>
            </v-flex>








        </v-layout>

    </v-card-text>
    <v-card-actions>
    <v-btn  @click="autoUpdaterStart()" block color="primary">Сохранить </v-btn>
   </v-card-actions>
    </v-card>
      </v-dialog>
    </div>

  </app-modalData>
</template>




<script>
import axios from 'axios'
export default {
props: ['results'],
 data: function(){
  return {
   starter: true ,  //  что бы отключить повторный запрос на обновление
   autoparams: false,


    modalData:{
     sb: {
       snackbar: false,
       color: 'success',
       text: ''
     },
     f: "",
     selectedItem: "in",
       header:{
         text:"",
          icon:"mdi-database",
         icons:[ ]
       },
     bar: {
         items:[
           {
              itemName: 'in',
              text:'Входящий трафик',
              f: null,
           },
           {
              itemName: 'out',
              text:'Исходящий трафик',
              f: null,
           },

         ],
         status: ""
       },
     content:{
       type:'pages',
         items:{

             in:{
               foundData:  { },
               meneger:{ },
             },
              out:{
               foundData:  { },
               meneger:{ },
             },

         },
       },


     operations:{

     }

    },
  }
},

methods: {

  f(fName){
  eval('this.'+fName+'()')
  },


  autoUpdaterStarter(){
    if(this.results.updating.auto){
      this.autoparams = false
      this.autoUpdaterOn()
    } else { this.autoparams = true }

  },
  autoUpdaterStart(){
    this.results.updating.interval = this.results.updating.intervalSet.sec + (this.results.updating.intervalSet.min * 60 ) + (this.results.updating.intervalSet.hours * 60 *60)
    this.autoparams = false
    this.autoUpdaterOn()
  },



 autoUpdaterOn(){

   if(this.results.updating.auto){
     this.results.updating.auto = false
     this.results.updating.timer == 'off'

     this.results.newInContentMenegment.items.autoExport.active = false
     this.results.newOutContentMenegment.items.autoExport.active = false
   } else {

     this.results.newInContentMenegment.items.autoExport.active = true
     this.results.newOutContentMenegment.items.autoExport.active = true


     this.results.updating.auto = true
     this.results.updating.timer = 'on'
   }
 },





  updateResult(process){
    this.clearUpdateResults()
    this.results.updating.inProccess = true
    this.results.selectedProccess = process
    this.results.modal = true
    console.log(process)
    this.updater(this.results.selectedProccess)
  },

 updater(process){
   //alert(process.process_name)
   this.results.updating.inProccess = true
   if(process.process_name !== 'filter'){
   this.updaterRequest('searcher/'+process.process_name+'.php', process)
 } else {
   this.updaterRequest('filter/'+process.process_name+'.php', process)
 }
 },

 updaterRequest (path , process){
   axios( 'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/'+path, {
        method: 'POST',
        data: {
          processId: process.process_id,
          updater: true
        }
      })
      .then( response => {
      this.results.newIn.foundData.foundIds = response.data.new_in
      this.results.newOut.foundData.foundIds = response.data.new_out
      this.results.contentType = response.data.content_type
      this.results.updating.inProccess = false

      })
 },


 reUpdater(){
    this.clearUpdateResults()
    this.updater(this.results.selectedProccess)
   // this.autoUpdater
 },



close(){

  this.results.modal = false
  this.starter = true
  this.results.contentType = 'updating'
  this.results.newInContentMenegment.items.autoExport.active = false
  this.results.newOutContentMenegment.items.autoExport.active = false

  this.results.newInContentMenegment.autoExport.isActive = false
  this.results.newInContentMenegment.autoExport.tasksList = []
  this.results.newOutContentMenegment.autoExport.isActive = false
  this.results.newOutContentMenegment.autoExport.tasksList = []

  this.clearUpdateResults()


  this.results.updating.auto = false
},

clearUpdateResults(){
  this.results.newIn.foundData.selector = false
  this.results.newIn.foundData.foundIds = []
  this.results.newIn.foundData.displayIds = []
  this.results.newIn.foundData.selectedIds = []
  this.results.newIn.foundData.offset = 0
  this.results.newIn.foundData.selectAll = false

  this.results.newOut.foundData.selector = false
  this.results.newOut.foundData.foundIds = []
  this.results.newOut.foundData.displayIds = []
  this.results.newOut.foundData.selectedIds = []
  this.results.newOut.foundData.offset = 0
  this.results.newOut.foundData.selectAll = false
},








},
beforeUpdate(){

},

computed: {
  metaData(){
    if(this.results.modal){
     this.modalData.header.text = 'обновление процесса'
     this.modalData.content.type = this.results.contentType


      this.modalData.content.items.in.meneger =   this.results.newInContentMenegment
      this.modalData.content.items.in.foundData =   this.results.newIn.foundData

      this.modalData.content.items.out.meneger =   this.results.newOutContentMenegment
      this.modalData.content.items.out.foundData =   this.results.newOut.foundData

      if(this.starter){this.updater(this.results.selectedProccess)}
       this.starter = false

      return this.modalData
    } else return false
    },

    autoUpdater(){

       if(this.results.updating.timer > 0 ) {
         if(this.results.updating.auto){

  //!this.updateHistory.updating.inProccess
     setTimeout( ()=>{
          if(!this.results.updating.inProccess){
            --this.results.updating.timer
          } else {
            --this.results.updating.timer
            ++this.results.updating.timer
          }
         }, 1000)
      return this.results.updating.timer
    }  else {
       this.results.updating.timer = this.results.updating.interval
       return this.results.updating.timer
    }
  } else if (this.results.updating.timer == 'off') {
    this.results.updating.timer = this.results.updating.interval
    return false
  } else if (this.results.updating.timer == 'on') {
    this.results.updating.timer = this.results.updating.interval
    return this.autoUpdater
  }  else  {
       this.reUpdater()
       this.results.updating.timer = this.results.updating.interval
       return  this.autoUpdater
    }
    },



},




}
</script>

<style  >

</style>
